import { ConnectionManagerNetworkKeys } from '../../helpers/constants';

export function getBaseAccessesUrlByNetwork(APIBaseURL, network) {
  switch (network) {
    case ConnectionManagerNetworkKeys.PIGEON_HOLE:
      return `${APIBaseURL}/pigeonholeAccesses`;

    default:
      return APIBaseURL;
  }
}

export function getBaseDeleteUrlByNetwork(APIBaseURL, network) {
  switch (network) {
    case ConnectionManagerNetworkKeys.PIGEON_HOLE:
      return `${APIBaseURL}/distribution/access/pigeonhole`;

    default:
      return APIBaseURL;
  }
}
